import axios from "../httpClient";

export function getPKOReportApi(visaType = "all", params = {}) {
  // Placeholder URL - replace with actual endpoint
  return axios.get(
    `/report/pko/ready-for-pko-count/${visaType.toLowerCase()}`,
    {
      params, // e.g., { search, startDate, endDate, page, itemsPerPage }
    },
  );
}
